import { PivotTable } from "./PivotTable";

import { registerAxis, registerEmptyTip, registerLegend, registerMenu, registerTitle, registerTooltip, registerAnimation } from "./components";

import { registerCustomCellStylePlugin } from "./plugins/custom-cell-style";

import { registerCheckboxCell, registerImageCell, registerProgressBarCell, registerRadioCell, registerSparkLineCell, registerTextCell, registerVideoCell } from "./scenegraph/group-creater/cell-type";

registerAxis(), registerEmptyTip(), registerLegend(), registerMenu(), registerTitle(), 
registerTooltip(), registerCustomCellStylePlugin(), registerAnimation(), registerCheckboxCell(), 
registerImageCell(), registerProgressBarCell(), registerRadioCell(), registerSparkLineCell(), 
registerTextCell(), registerVideoCell();

export class PivotTableAll extends PivotTable {}
//# sourceMappingURL=PivotTable-all.js.map